import styled from 'styled-components';

export const EmptyState = styled.div`
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0 15px;
  }
`;

export const EmptyStateCount = styled.div`
  margin-bottom: 20px;
  padding-bottom: 5px;
  @media (${props => props.theme.underScreenSmall}) {
    border-bottom: ${({ theme }) => theme.greyLine};
  }
`;

export const QueryText = styled.span`
  font-weight: bold;
`;
